<template>
  <div :class="cssClass">
    <Checkbox
      v-for="checkbox in checkboxes"
      :key="checkbox.id"
      :label="checkbox.label"
      :rules="checkbox.rules"
      :name="checkbox.name"
      :id="checkbox.id"
      :checked="checkbox.checked"
      :data-testid="checkbox.dataTestid"
    />
  </div>
</template>

<script>
import Checkbox from '@/components/form-controls/Checkbox'

export default {
  name: 'DynamicCheckboxes',
  components: { Checkbox },
  props: {
    checkboxes: Array,
    cssClass: String
  }
}
</script>
